import * as React from "react";
import type { SVGProps } from "react";
const SvgLayout02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={2}
      d="M9 2.4v19.2M13.2 6h3.6m-3.6 3.6h3.6m-3.6 3.6h.6M6 21.6h12a3.6 3.6 0 0 0 3.6-3.6V6A3.6 3.6 0 0 0 18 2.4H6A3.6 3.6 0 0 0 2.4 6v12A3.6 3.6 0 0 0 6 21.6Z"
    />
  </svg>
);
export default SvgLayout02;
